__turbopack_context__.v({
  "PodcastBanner": "PodcastBannerRichText-module-scss-module__Itc1ZG__PodcastBanner",
  "loader": "PodcastBannerRichText-module-scss-module__Itc1ZG__loader",
});
